export default __webpack_public_path__ + "static/media/9S.6c7e4615.svg";